var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBody2Right1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 804.09 717.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-body-1 {\n        fill: #d61800;\n      }\n\n      .cls-body-2 {\n        fill: var(--custom-color, #fa) !important;\n      }\n\n      .cls-skin-color {\n        fill: var(--custom-skin-color, #dd8f5f) !important;\n      }\n\n      .cls-body-4 {\n        fill: #fff;\n      }\n\n      .cls-body-5 {\n        fill: #0f8d4e;\n      }\n\n      .cls-body-6 {\n        fill: #4b3e50;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M478.76,147.76l-54.99-79.96-244.26,168c-9.07-7.63-19.52-13.93-31.21-18.41-56.3-21.58-119.44,6.56-141.02,62.86-21.58,56.3,6.56,119.44,62.86,141.02,56.3,21.58,119.44-6.56,141.02-62.86,3.96-10.34,6.23-20.9,6.98-31.4l260.63-179.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M378.03,229.29c30.88-1.42,66.3-15.17,97.71-40.45,58.62-47.18,81.07-116.57,50.15-155.01-30.93-38.43-103.52-31.35-162.15,15.83-31.41,25.28-52.42,56.94-60.42,86.8l74.71,92.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-4",
    cx: 350.45,
    cy: 629.92,
    rx: 78.12,
    ry: 100.08,
    transform: "translate(-356.41 488.64) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-1",
    cx: 351.92,
    cy: 617.22,
    rx: 78.12,
    ry: 100.08,
    transform: "translate(-346.22 485.28) rotate(-49.61)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-4",
    cx: 615.11,
    cy: 573.69,
    rx: 78.12,
    ry: 100.08,
    transform: "translate(-197.73 789.94) rotate(-57.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-body-1",
    cx: 614.73,
    cy: 560.91,
    rx: 78.12,
    ry: 100.08,
    transform: "translate(-187.08 783.63) rotate(-57.9)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-5",
    d: "M576.62,474.11l1.09,28.46c.53,13.75,22.86,24.06,49.87,23.02,27.02-1.04,48.49-13.03,47.96-26.78l-1.09-28.46-97.83,3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-5",
    d: "M408.76,532.51l-7.81,27.39c-3.77,13.24-27.91,17.96-53.91,10.55s-44.02-24.15-40.25-37.39l7.81-27.39,94.16,26.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-6",
    d: "M539.79,340.76s-34.32,43.45-35.49,105.84c0,0,134.18,77.1,226.95,26.18l6.72-33.46-3.41-88.86-194.77-9.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-6",
    d: "M506.67,371.64s22.95,85.77,9.3,146.66c0,0-148.63,43.11-226.68-28.35h0c.93-22.67,4.16-45.19,9.66-67.21l20.76-83.21,186.97,32.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M402.72,393.8c-102.15-32.04-175.2-98.97-185.19-177.98l-.02-.18c-1.12-8.93-1.22-17.94-.29-26.89l2-19.27c1.1.08,2.19.15,3.27.21,40.93,2.15,77.9-21.93,89.48-57.22L348.86,0h53.86s136.84,0,136.84,0h53.86s36.89,112.47,36.89,112.47c11.57,35.29,48.55,59.37,89.48,57.22,1.08-.06,2.17-.13,3.27-.21l1.99,19.09c.94,9.07.85,18.2-.29,27.26h0c-6.06,47.97-35.37,91.49-80.33,125.44-52.63,39.76-119.9,60.06-188.7,59.69-19.65-.11-38.93-1.95-53-7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-skin-color",
    d: "M434.72,71.99l-63.28,73.57,224.76,193.32c-5.07,10.72-8.48,22.43-9.84,34.88-6.51,59.94,36.82,113.81,96.76,120.32,59.94,6.51,113.81-36.81,120.32-96.76,6.51-59.94-36.82-113.81-96.76-120.32-11-1.19-21.8-.7-32.14,1.26l-239.82-206.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-body-2",
    d: "M539.26,148.58c-9.25-29.49-31.58-60.23-64.04-84.16-60.57-44.65-133.4-48.65-162.67-8.94-29.27,39.71-3.9,108.09,56.67,152.74,32.46,23.93,68.43,36.16,99.34,36.27l70.7-95.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody2Right1);
export default __webpack_public_path__ + "static/media/body2-right1.d7e8eadce0d5d95862e364dcf9f8c300.svg";
export { ForwardRef as ReactComponent };